import type {
  AgentDefinition,
  AgentRun,
  InventoryItem,
  Recommendation,
  StationState,
  WorkerState,
} from "../types";

export const workers: WorkerState[] = [
  {
    id: "A",
    name: "Minjun",
    role: "Prep specialist",
    color: "#ff7a00",
    position: [5.3, 4.2, 0],
    targetPosition: [5.3, 4.2, 0],
    station: "center_prep_table",
    status: "available",
  },
  {
    id: "B",
    name: "Jiwoo",
    role: "Wok specialist",
    color: "#3976f6",
    position: [6.7, 2, 0],
    targetPosition: [6.7, 2, 0],
    station: "gas_range",
    status: "active",
  },
  {
    id: "C",
    name: "Seojun",
    role: "Fry and plating",
    color: "#20ad78",
    position: [4.5, 2.1, 0],
    targetPosition: [4.5, 2.1, 0],
    station: "deep_fryer",
    status: "active",
  },
];

export const stations: StationState[] = [
  {
    id: "cold_prep_station",
    label: "Cold Prep / Garnish Rail",
    category: "prep",
    maxCapacity: 6,
    possibleActions: [
      "dice",
      "slice",
      "chop",
      "julienne",
      "mince",
      "peel",
      "portion",
      "toss",
      "mix",
      "plate_cold",
      "chill_hold",
    ],
    queue: 2,
    etaSeconds: 170,
    load: 42,
    position: [6, 4.05, 0.05],
    width: 2.9,
    depth: 0.58,
    status: "normal",
  },
  {
    id: "under_counter_fridge",
    label: "Prep Table Refrigerator",
    category: "cold_storage",
    maxCapacity: null,
    possibleActions: ["store_cold", "retrieve", "marinate", "cold_hold"],
    queue: 1,
    etaSeconds: 35,
    load: 54,
    position: [6, 3.72, 0.05],
    width: 2.9,
    depth: 0.32,
    status: "normal",
  },
  {
    id: "center_prep_table",
    label: "Center Cutting Station",
    category: "prep",
    maxCapacity: 2,
    possibleActions: [
      "dice",
      "slice",
      "chop",
      "mince",
      "julienne",
      "portion",
      "debone",
      "fillet",
      "trim",
      "butterfly",
      "tenderize",
      "bread",
      "batter",
      "plate",
    ],
    queue: 2,
    etaSeconds: 145,
    load: 58,
    position: [6, 4.05, 0.05],
    width: 2.9,
    depth: 0.58,
    status: "normal",
  },
  {
    id: "microwave_station",
    label: "Microwave",
    category: "reheat",
    maxCapacity: 1,
    possibleActions: ["reheat", "defrost", "steam", "melt", "soften"],
    queue: 1,
    etaSeconds: 75,
    load: 36,
    position: [2.05, 1.25, 0.05],
    width: 1,
    depth: 0.55,
    status: "normal",
  },
  {
    id: "convection_oven",
    label: "Double Convection Oven",
    category: "oven",
    maxCapacity: 2,
    possibleActions: ["bake", "roast", "reheat", "broil", "proof", "dehydrate", "hold_warm"],
    queue: 2,
    etaSeconds: 410,
    load: 66,
    position: [3.25, 1.25, 0.05],
    width: 1.1,
    depth: 0.55,
    status: "watch",
  },
  {
    id: "deep_fryer",
    label: "Deep Fryer",
    category: "fryer",
    maxCapacity: 2,
    possibleActions: ["fry", "deep_fry", "blanch_fry", "re_fry", "drain_oil"],
    queue: 4,
    etaSeconds: 280,
    load: 68,
    position: [4.55, 1.25, 0.05],
    width: 1.35,
    depth: 0.55,
    status: "watch",
  },
  {
    id: "flat_top_griddle",
    label: "Flat-Top Griddle",
    category: "griddle",
    maxCapacity: null,
    possibleActions: ["grill", "sear", "toast", "saute", "render_fat", "flip", "press", "warm"],
    queue: 3,
    etaSeconds: 230,
    load: 64,
    position: [5.75, 1.25, 0.05],
    width: 1,
    depth: 0.55,
    status: "watch",
  },
  {
    id: "gas_range",
    label: "Gas Range / Stove Top",
    category: "stove",
    maxCapacity: 6,
    possibleActions: [
      "boil",
      "simmer",
      "steam",
      "stir_fry",
      "saute",
      "poach",
      "blanch",
      "reduce_sauce",
      "deglaze",
      "temper",
      "toast_spices",
    ],
    queue: 5,
    etaSeconds: 390,
    load: 84,
    position: [6.85, 1.25, 0.05],
    width: 2,
    depth: 1.15,
    status: "busy",
  },
  {
    id: "range_oven",
    label: "Oven below Gas Range",
    category: "oven",
    maxCapacity: 1,
    possibleActions: ["bake", "roast", "braise", "hold_warm", "finish_dish"],
    queue: 1,
    etaSeconds: 360,
    load: 46,
    position: [6.85, 1.02, 0.05],
    width: 1.6,
    depth: 0.28,
    status: "normal",
  },
  {
    id: "reach_in_fridge",
    label: "Reach-In Refrigerator",
    category: "cold_storage",
    maxCapacity: null,
    possibleActions: ["store_cold", "retrieve", "cold_hold", "label_date"],
    queue: 1,
    etaSeconds: 25,
    load: 72,
    position: [9.2, 1.35, 0.05],
    width: 1.1,
    depth: 0.55,
    status: "normal",
  },
  {
    id: "reach_in_freezer",
    label: "Reach-In Freezer",
    category: "frozen_storage",
    maxCapacity: null,
    possibleActions: ["store_frozen", "retrieve", "defrost", "label_date"],
    queue: 1,
    etaSeconds: 30,
    load: 61,
    position: [10.25, 1.35, 0.05],
    width: 1.1,
    depth: 0.55,
    status: "normal",
  },
  {
    id: "dry_storage_shelf",
    label: "Dry Storage Shelving",
    category: "dry_storage",
    maxCapacity: null,
    possibleActions: ["store_dry", "retrieve", "measure", "portion_bulk", "label_date", "restock"],
    queue: 2,
    etaSeconds: 80,
    load: 48,
    position: [11.15, 1.4, 0.05],
    width: 1.1,
    depth: 0.5,
    status: "normal",
  },
  {
    id: "dish_storage_shelf",
    label: "Plate / Dish Storage",
    category: "storage",
    maxCapacity: null,
    possibleActions: ["store_dish", "retrieve", "stack", "restock"],
    queue: 1,
    etaSeconds: 20,
    load: 57,
    position: [2.15, 5.9, 0.05],
    width: 2.6,
    depth: 1.1,
    status: "normal",
  },
  {
    id: "plate_storage_table",
    label: "Plate and Bowl Storage",
    category: "storage",
    maxCapacity: null,
    possibleActions: ["store_dish", "retrieve", "stack"],
    queue: 1,
    etaSeconds: 15,
    load: 70,
    position: [5.1, 4.05, 0.05],
    width: 1.1,
    depth: 0.38,
    status: "normal",
  },
  {
    id: "three_compartment_sink",
    label: "Three-Compartment Sink",
    category: "wash",
    maxCapacity: 3,
    possibleActions: ["wash", "rinse", "sanitize", "soak", "scrub"],
    queue: 3,
    etaSeconds: 210,
    load: 55,
    position: [7.9, 5.7, 0.05],
    width: 2.7,
    depth: 1.2,
    status: "normal",
  },
  {
    id: "dishwasher",
    label: "Commercial Dishwasher",
    category: "wash",
    maxCapacity: 1,
    possibleActions: ["wash", "sanitize", "load", "unload", "dry"],
    queue: 2,
    etaSeconds: 170,
    load: 76,
    position: [9.75, 5.75, 0.05],
    width: 1,
    depth: 0.55,
    status: "watch",
  },
  {
    id: "trash_station",
    label: "Waste Bin",
    category: "waste",
    maxCapacity: null,
    possibleActions: ["discard", "compost", "recycle", "empty_bin"],
    queue: 1,
    etaSeconds: 40,
    load: 81,
    position: [10.5, 4.7, 0.05],
    width: 0.6,
    depth: 0.6,
    status: "busy",
  },
];

export const inventory: InventoryItem[] = [
  {
    id: "carrots",
    name: "Carrots",
    current: 5,
    target: 12,
    unit: " pcs",
    position: [9.9, 1.9, 0.9],
    asset: "carrot",
  },
  {
    id: "cabbage",
    name: "Cabbage",
    current: 3,
    target: 8,
    unit: " heads",
    position: [10.3, 2.05, 0.9],
    asset: "cabbage",
  },
  {
    id: "noodles",
    name: "Fresh noodles",
    current: 7,
    target: 18,
    unit: " portions",
    position: [3.1, 2.25, 1.05],
    asset: "noodles",
  },
  {
    id: "bowls",
    name: "Noodle bowls",
    current: 14,
    target: 20,
    unit: " pcs",
    position: [2.45, 6.25, 0.9],
    asset: "bowl",
  },
];

export const recommendations: Recommendation[] = [
  {
    id: "rec-prep-vegetables",
    workerId: "A",
    stationId: "center_prep_table",
    title: "Prep ahead for the 7 p.m. jajang rush",
    ingredients: ["1 carrot", "1 cabbage"],
    tool: "green cutting board and chef's knife",
    action: "move to Prep and julienne to 4 mm",
    reason: "Vegetable prep became the constraint after 18:48 in 7 of 8 similar Fridays.",
    targetMenu: "12 bowls - Jajangmyeon",
    targetImage: "/images/jajangmyeon.png",
    asset: "carrot",
    route: [
      [5.3, 4.2, 0.13],
      [4.1, 3.8, 0.13],
      [4.1, 2.5, 0.13],
      [4.8, 1.9, 0.13],
      [9.2, 1.6, 0.13],
      [6.4, 1.75, 0.13],
      [4.2, 2.5, 0.13],
      [4.2, 3.8, 0.13],
      [5.2, 4.2, 0.13],
      [6, 4.25, 0.13],
    ],
    status: "proposed",
    evidence: "Firestore Vector similarity 0.91 - expected wait down 3m 42s",
  },
  {
    id: "rec-noodle-portions",
    workerId: "A",
    stationId: "cold_prep_station",
    title: "Pre-portion noodles for the 7 p.m. wave",
    ingredients: ["6 portions of fresh noodles"],
    tool: "2 noodle baskets",
    action: "weigh six portions at Cold Prep",
    reason: "Vegetable prep is covered, but the noodle queue is forecast to reach five in 13 minutes.",
    targetMenu: "6 bowls - Jajangmyeon",
    targetImage: "/images/jajangmyeon.png",
    asset: "noodles",
    route: [
      [5.3, 4.2, 0.13],
      [4.8, 4.55, 0.13],
      [5.3, 4.55, 0.13],
      [6, 4.45, 0.13],
    ],
    status: "proposed",
    evidence: "Pioneer alternate plan - table completion spread down 58s",
  },
];

export const agents: AgentDefinition[] = [
  {
    id: "perception",
    name: "Perception Agent",
    owner: "WeRHungry",
    role: "Turns camera and KDS signals into kitchen task state",
    input: "worker, tray, station enter/exit",
    output: "task_started, task_finished, queue_changed",
    permission: "Read sensors - write observations",
    status: "running",
    lastRun: "now",
  },
  {
    id: "memory",
    name: "Memory Agent",
    owner: "Firestore Vector",
    role: "Retrieves restaurant episodes that match the live situation",
    input: "day, bookings, queues, equipment, stock, staffing",
    output: "similar episodes, outcomes, effective responses",
    permission: "Search episodes - append outcomes",
    status: "running",
    lastRun: "12s ago",
  },
  {
    id: "reasoning",
    name: "Reasoning Agent",
    owner: "Pioneer",
    role: "Classifies causes and ranks structured action candidates",
    input: "live state plus Firestore Vector evidence",
    output: "cause, action candidates, confidence",
    permission: "Inference - submit correction feedback",
    status: "ready",
    lastRun: "28s ago",
  },
  {
    id: "forecast",
    name: "Demand Forecast Agent",
    owner: "WeRHungry",
    role: "Forecasts menu demand and prep quantities 30-60 minutes ahead",
    input: "POS history, bookings, delivery mix, current stock",
    output: "menu demand distribution",
    permission: "Read history - write forecasts",
    status: "running",
    lastRun: "1m ago",
  },
  {
    id: "scheduler",
    name: "Scheduler Agent",
    owner: "WeRHungry",
    role: "Computes anticipatory prep and live task order",
    input: "forecast, durations, workers, equipment, constraints",
    output: "candidate assignment plan",
    permission: "Create candidates - cannot activate",
    status: "running",
    lastRun: "now",
  },
  {
    id: "critic",
    name: "Critic Agent",
    owner: "Guild",
    role: "Checks safety, fairness, active work and waste risk",
    input: "candidate plan plus kitchen state",
    output: "approved or rejected plus warnings",
    permission: "Review - may reject",
    status: "running",
    lastRun: "now",
  },
  {
    id: "coordinator",
    name: "Coordinator Agent",
    owner: "Guild",
    role: "Turns approved plans into clear worker instructions",
    input: "approved assignment",
    output: "NOW / NEXT / IF-THEN",
    permission: "Notify - write active tasks",
    status: "ready",
    lastRun: "2m ago",
  },
  {
    id: "qa",
    name: "Journey QA",
    owner: "Replay",
    role: "Tests the deployed journey from 3D load through band approve and pass",
    input: "deployed URL plus test journey",
    output: "recording, failing step, root cause",
    permission: "Test-only - cannot write production state",
    status: "planned",
    lastRun: "after deploy",
  },
];

export const initialAgentRuns: AgentRun[] = [
  {
    id: "run-104",
    time: "18:35:18",
    agent: "Guild - Orchestrator",
    summary: "Routed the band event into Worker A's session",
    status: "done",
  },
  {
    id: "run-103",
    time: "18:35:17",
    agent: "Firestore Vector - Memory",
    summary: "Retrieved 8 similar Friday dinner episodes",
    evidence: "best similarity 0.91",
    status: "done",
  },
  {
    id: "run-102",
    time: "18:35:16",
    agent: "Pioneer - Reasoning",
    summary: "Ranked anticipatory vegetable prep as the top action",
    evidence: "confidence 0.87",
    status: "done",
  },
];
